'use client'

import { Link } from '@repo/web-ui/components/link'

import { useMyAccountNavigationSections } from '../_hooks/use-my-account-navigation-sections'
import { Card } from './card'

export function MyAccountLinksBlock() {
  const sections = useMyAccountNavigationSections()
  return (
    <Card>
      {sections.map(section => (
        <div key={section.title} className="flex flex-col gap-4 px-4 pb-9 pt-5">
          <h2 className="text-20 font-bold capitalize">{section.title}</h2>
          <div className="@lg:grid-cols-2 @sm:gap-x-2 @3xl:grid-cols-3 grid grid-cols-1 gap-y-6">
            {section.items.map(link => {
              const Icon = link.icon
              return (
                <Link
                  key={link.path}
                  href={link.path}
                  className="rounded-4 group flex gap-x-6 gap-y-6 border border-[#84B4DD] px-3 py-4"
                >
                  <span className="flex h-[3.25rem] w-[3.25rem] shrink-0 items-center justify-center rounded-full bg-[#B3D7DC]">
                    <Icon className="h-9 w-9 text-[#103D45]" />
                  </span>
                  <span className="flex flex-col gap-1.5 break-words">
                    <span className="text-14 group-hover:text-cf-sky-blue-400 block whitespace-normal font-bold text-[#2A1F3F] [word-break:break-word]">
                      {link.title}
                    </span>
                    <span className="text-12 whitespace-normal font-normal text-[#7B898D] [word-break:break-word]">
                      {link.description}
                    </span>
                  </span>
                </Link>
              )
            })}
          </div>
        </div>
      ))}
    </Card>
  )
}
